import { render, staticRenderFns } from "./garbageRegister.vue?vue&type=template&id=4276cc8a&scoped=true"
import script from "./garbageRegister.vue?vue&type=script&lang=js"
export * from "./garbageRegister.vue?vue&type=script&lang=js"
import style0 from "./garbageRegister.vue?vue&type=style&index=0&id=4276cc8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4276cc8a",
  null
  
)

export default component.exports